import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import { motion } from 'framer-motion';

// --- SAJÁT KÉPEK IMPORTÁLÁSA ---
// @ts-ignore
import tieImg from '../videos/tie.PNG';
// @ts-ignore
import masniImg from '../videos/masni.PNG';
// @ts-ignore
import masni2Img from '../videos/masni2.PNG';

const colorSwatches = [
  '#03466a', 
  '#0f7fbf', 
  '#1567d1', 
  '#b3dcf3', 
  '#A2B9C6', 
];

const DressCode: React.FC = () => {
  return (
    <Box sx={{ bgcolor: 'transparent', py: 15 }}>
      <Container maxWidth="md">
        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }} 
          transition={{ duration: 0.8 }}
        >
          
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="h2" sx={{ mb: 2,  color: 'primary.main' }}>
              Dress Code
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 4 }}>
              {colorSwatches.map((color, idx) => (
                <Box 
                  key={idx}
                  sx={{ 
                    width: 30, 
                    height: 30, 
                    borderRadius: '50%', 
                    bgcolor: color,
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                    border: '1px solid rgba(0,0,0,0.05)'
                  }} 
                />
              ))}
            </Box>
          </Box>

          <Box sx={{ position: 'relative', px: { xs: 2, md: 5 }, mt: 8 }}>
            
            {/* NYAKKENDŐ KÉP: Mobilon bal alul, asztalin bal felül */}
            <Box 
              component="img"
              src={tieImg}
              alt="Nyakkendő"
              sx={{ 
                position: 'absolute', 
                // Mobilon az 'auto' kikapcsolja a felső igazítást, asztalin marad a -60
                top: { xs: 'auto', md: -60 }, 
                // Mobilon -40 pixelre lesz alulról, asztalin kikapcsoljuk az 'auto'-val
                bottom: { xs: -40, md: 'auto' }, 
                left: { xs: -10, md: -30 }, 
                width: { xs: 80, md: 100 }, 
                height: 'auto',
                objectFit: 'contain',
                transform: 'rotate(-15deg)',
                zIndex: 0
              }}
            />

            {/* MASNI KÉP: Mobilon jobb felül, asztalin jobb alul */}
            <Box 
              component="img"
              src={masniImg} 
              alt="Masni"
              sx={{ 
                position: 'absolute', 
                // Mobilon -40 pixelre lesz felülről, asztalin kikapcsoljuk
                top: { xs: -40, md: 'auto' }, 
                // Mobilon kikapcsoljuk az alsó igazítást, asztalin marad a -50
                bottom: { xs: 'auto', md: -50 }, 
                right: { xs: -10, md: -30 }, 
                width: { xs: 80, md: 100 }, 
                height: 'auto',
                objectFit: 'contain',
                transform: 'rotate(15deg)',
                zIndex: 0
              }}
            />

            <Paper 
              elevation={0} 
              sx={{ 
                p: 6, 
                position: 'relative',
                zIndex: 1, 
                textAlign: 'center', 
                bgcolor: 'transparent',

              }}
            >
              <Typography 
                variant="body1" 
                sx={{ 
                  
                  fontSize: '1.2rem', 
                  lineHeight: 1.8, 
                  color: 'primary.main', 
                  fontStyle: 'italic' 
                }}
              >
                  Ha velünk ünnepled a nagy napot,<br />
                  Egy apró kérésünk is akad ott,<br />
                  Öltözékeden legyen egy kis <strong style={{ color: '#4A90E2' }}>kék</strong>,<br />
                  Hogy még szebb legyen a közös emlék.
              </Typography>
            </Paper>

          </Box>

        </motion.div>
      </Container>
    </Box>
  );
};

export default DressCode;